import {
    TemplateFormModule
} from './template-form-module/template-form-module';
import { BaseRequest } from 'source/app/objects/request/base-request';
import { Property } from 'source/app/objects/request/properties/property';
import { Dictionary } from 'source/app/objects/dictionary';
import { CheckBoxComboBoxProperty } from 'source/app/objects/request/properties/check-box-combo-box-property';
import { PropertyLabel } from 'source/app/objects/request/property-label';
import { CheckBoxProperty } from 'source/app/objects/request/properties/check-box-property';
import { ComboBoxProperty } from 'source/app/objects/request/properties/combo-box-property';
import { SelectionMode } from 'source/app/objects/enums/selection-mode';
import { DatePickerProperty } from 'source/app/objects/request/properties/date-picker-property';
import { DateExtensions } from 'source/app/objects/extensions/date-extensions';
import { Orientation } from 'source/app/objects/enums/orientation';
import { DateRangePickerProperty } from 'source/app/objects/request/properties/date-range-picker-property';
import { DateRange } from 'source/app/objects/date-range';
import { DateTimePickerProperty } from 'source/app/objects/request/properties/date-time-picker-property';
import { MultiSelectTextBoxProperty } from 'source/app/objects/request/properties/multi-select-text-box-property';
import { NumericBoxProperty } from 'source/app/objects/request/properties/number-box-property';
import { RadioGroupProperty } from 'source/app/objects/request/properties/radio-group-property';
import { RadioButtonItem } from 'source/app/objects/request/properties/radio-button-item';
import { TextareaProperty } from 'source/app/objects/request/properties/textarea-property';
import { TemplateProperty } from 'source/app/objects/request/properties/template-property';
import { TextBoxProperty } from 'source/app/objects/request/properties/text-box-property';
import { Validators } from 'source/app/objects/validation/validator';

export class FormRequest extends BaseRequest {
    constructor( ) {
        super();

        this.Properties = new Dictionary<Property>([
            {
                key: "CheckBoxComboBox",
                value: new CheckBoxComboBoxProperty(
                    new PropertyLabel("CheckBoxComboBox"),
                    undefined,
                    "Name",
                    "Watermark",
                )
            },
            {
                key: "CheckBox",
                value: new CheckBoxProperty(
                    new PropertyLabel(),
                    true,
                    "CheckBox"
                )
            },
            {
                key: "ComboBox",
                value: new ComboBoxProperty(
                    new PropertyLabel("ComboBox"),
                    undefined,
                    "Name",
                    "Watermark",
                    SelectionMode.Single, 
                    undefined
                )
            },
            {    
                key: "DatePicker", 
                value: new DatePickerProperty(
                    new PropertyLabel("DatePicker"),
                    DateExtensions.DateToday
                )
            },
            {
                key: "DatePickerTo",
                value: new DatePickerProperty(
                    new PropertyLabel("DatePickerTo", "DatePickerTo  Horizontal", "200"),
                    undefined, undefined, Orientation.Horizontal
                )
            },            
            {
                key: "DateRangePicker",
                value: new DateRangePickerProperty(
                    new PropertyLabel("DateRangePicker"), 
                    new DateRange(DateExtensions.DateToday, DateExtensions.AddYear(DateExtensions.DateToday, 2)),
                    "Today's Date"
                )
            },
            {
                key: "DateTimePicker",
                value: new DateTimePickerProperty(
                    new PropertyLabel("DateTimePicker"),
                    DateExtensions.DateTimeToday,
                )
            },
            {
                key: "MultiSelectTextBox",
                value: new MultiSelectTextBoxProperty(
                    new PropertyLabel("MultiSelectTextBox"),
                    100
                )
            },            
            {
                key: "NumericBox",
                value: new NumericBoxProperty(
                    new PropertyLabel("NumericBox"),
                    100
                )
            },
            {
                key: "RadioGroup",
                value: new RadioGroupProperty(
                    new PropertyLabel("RadioGroup"),
                    [
                        new RadioButtonItem(true, "Item 1", "Item1"),
                        new RadioButtonItem(false, "Item 2", "Item2")
                    ]
                )
            },
            {
                key: "Template",
                value: new TemplateProperty(
                    new PropertyLabel("Template"),
                    undefined,
                    "<div>Template1 {{Property.Label.Name}} <template-form-component></template-form-component></div>",
                    [TemplateFormModule]
                )
            },
            {
                key: "Textarea",
                value: new TextareaProperty(
                    new PropertyLabel("Textarea"),
                    undefined,
                    "Enter text"
                )
            },
            {
                key: "TextBox",
                value: new TextBoxProperty(
                    new PropertyLabel("TextBox"),
                    undefined,
                    "Enter text"
                )
            },
            {
                key: "TextBoxIsRequired",
                value: new TextBoxProperty(
                    new PropertyLabel("TextBox Is Required", "TextBox Label", undefined, true),
                    undefined,
                    "Enter text"
                )
            },
            {
                key: "TextBoxHorizontal",
                value: new TextBoxProperty(
                    new PropertyLabel("TextBox Horizontal","TextBox Horizontal", undefined, true),
                    undefined,
                    "Enter text",
                    Orientation.Horizontal                    
                )
            }
        ]);  
    }

    public Validation() {

        Validators.IsRequired(this.Properties["CheckBoxComboBox"]);
        Validators.IsRequired(this.Properties["CheckBox"]);
        Validators.IsRequired(this.Properties["ComboBox"]);
        Validators.IsRequired(this.Properties["DatePicker"]);
        //Validators.IsRequired(this.Properties["DateRangePicker"]);
        Validators.IsRequired(this.Properties["DateTimePicker"]);
        Validators.IsRequired(this.Properties["NumericBox"]);
        Validators.IsRequired(this.Properties["RadioGroup"]);
        Validators.IsRequired(this.Properties["Template"]);
        Validators.IsRequired(this.Properties["Textarea"]);
        Validators.IsRequired(this.Properties["TextBox"]);
        Validators.IsRequired(this.Properties["TextBoxIsRequired"]);
        Validators.IsRequired(this.Properties["TextBoxHorizontal"]);

        Validators.IsMinMax(this.Properties["NumericBox"], 1);
        Validators.IsDateBeforeAfter(this.Properties["DatePicker"], this.Properties["DatePickerTo"]);
        Validators.IsDateRangeBeforeAfter(this.Properties["DateRangePicker"]);
    }
    
    public ToRequest() {
        return {
            "CheckBoxComboBox": this.Properties["CheckBoxComboBox"].Items,
            "CheckBox": this.Properties["CheckBox"].Item,
            "ComboBox": this.Properties["ComboBox"].Item.Start,
            "DatePicker": this.Properties["DatePicker"].Item.Finish,
            "DateRangePicker Start": this.Properties["DateRangePicker"].Item.Start,
            "DateRangePicker Finish": this.Properties["DateRangePicker"].Item.Finish,
            "NumericBox": this.Properties["NumericBox"].Item.Code,
            "RadioGroup": this.Properties["RadioGroup"].Item,            
            "Template": this.Properties["Template"].Item.Code,
            "Textarea": this.Properties["Textarea"].Item,
            "TextBox": this.Properties["TextBox"].Item,
            "TextBoxIsRequired": this.Properties["TextBoxIsRequired"].Item,
            "TextBoxHorizontal": this.Properties["TextBoxHorizontal"].Item,
        }
    }

    public ToFilter() {
        var filter = [];
        //filter.push({Name: "CheckBoxComboBox: ", Value: this.Properties["CheckBoxComboBox"].Item.Name + ", " });
        // filter.push({Name: "Date: ", Value: this.Properties["Date"].Item.Name + ", " });
        // filter.push({ Name: "TextBox: ", Value: this.Properties["TextBox"].Item + ", " });
        // filter.push({ Name: "TextArea: ", Value: this.Properties["TextArea"].Item + ", " });
        // filter.push({Name: "ComboBox: ", Value: this.Properties["ComboBox"].Item + ", " });
        // filter.push({Name: "Number: ", Value: this.Properties["Number"].Item.Name + ", " });
        // filter.push({ Name: "CheckBox: ", Value: this.Properties["CheckBox"].Item + ", " });
        // filter.push({ Name: "RadioButton: ", Value: this.Properties["RadioButton"].Item });

        return filter;
    }
}


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/form-controls/form-request.ts